/* eslint-disable no-magic-numbers */
import { GIGA, MEGA } from "utils/common";
import { imageMaxBytes, videoMaxBytes } from "social/utils";

export const MAX_VIDEO_BYTES = videoMaxBytes(4 * GIGA);
export const MAX_THUMBNAIL_BYTES = imageMaxBytes(10 * MEGA);

export const MIN_VIDEO_SEC = 5;
export const MAX_VIDEO_MIN = 15;
